module.exports = __webpack_public_path__ + "media/images/loading-74ab62d990388fdc2cda2b46a7392fbc.gif";